export const LAST_UPDATED = '2025-12-01';
